// src/components/MyEventsPage.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../AuthContext';

export default function MyEventsPage() {
  const { user, loginWithGoogle } = useAuth();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    const q = query(
      collection(db, 'events'),
      where('hostUid', '==', user.uid),
      orderBy('createdAt', 'desc')
    );
    const unsub = onSnapshot(q, snap => {
      setEvents(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return unsub;
  }, [user]);

  if (!user) {
    return (
      <div className="page"><div className="container">
        <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
          <p className="mb-2">ログインが必要です</p>
          <button className="btn btn-primary" onClick={loginWithGoogle}>Googleでログイン</button>
        </div>
      </div></div>
    );
  }

  return (
    <div className="page">
      <div className="container">
        <div className="flex items-center justify-between mb-2">
          <h1 style={{ fontSize: 20, fontWeight: 600 }}>自分のイベント</h1>
          <Link to="/create"><button className="btn btn-primary btn-sm">+ 新規作成</button></Link>
        </div>

        {loading && <div className="spinner" />}

        {!loading && events.length === 0 && (
          <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
            <p className="text-muted">まだイベントがありません</p>
            <Link to="/create" style={{ display: 'block', marginTop: 12 }}>
              <button className="btn btn-primary">最初のイベントを作成</button>
            </Link>
          </div>
        )}

        {events.map(ev => (
          <Link key={ev.id} to={`/event/${ev.id}`} style={{ textDecoration: 'none' }}>
            <div className="card" style={{ cursor: 'pointer', transition: 'border-color 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.borderColor = '#1D9E75'}
              onMouseLeave={e => e.currentTarget.style.borderColor = ''}>
              <div className="flex items-center justify-between mb-1">
                <div style={{ fontWeight: 500 }}>{ev.title}</div>
                {ev.closedAt
                  ? <span className="badge" style={{ background: '#FCEBEB', color: '#791F1F' }}>締め切り済み</span>
                  : <span className="badge badge-ok">受付中</span>
                }
              </div>
              <div className="text-sm text-muted">
                候補日 {ev.slots?.length || 0}件
                {ev.deadline && ` ・ 締め切り ${ev.deadline}`}
              </div>
              {ev.memo && <p className="text-sm text-muted mt-1" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ev.memo}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
